import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-277a27d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-progress-bar mr-n4" }
const _hoisted_2 = {
  key: 0,
  class: "item-operator-info"
}
const _hoisted_3 = {
  key: 0,
  class: "item-tour-info"
}
const _hoisted_4 = { class: "item-operator-info-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "px-4" }, "Ankunft")
], -1))
const _hoisted_6 = { class: "item-prio px-0 text-small" }
const _hoisted_7 = {
  class: "item-prio-label",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_8 = {
  class: "item-operator-info",
  style: {"flex":"1"}
}
const _hoisted_9 = { class: "item-operator-info-inner" }
const _hoisted_10 = { class: "ml-2 item-prio" }
const _hoisted_11 = { class: "px-0" }
const _hoisted_12 = { class: "item-prio-label" }
const _hoisted_13 = {
  key: 1,
  class: "item-operator-info"
}
const _hoisted_14 = { class: "item-operator-info-inner" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "px-3" }, "Abfahrt")
], -1))
const _hoisted_16 = { class: "item-prio px-0 text-small" }
const _hoisted_17 = {
  class: "item-prio-label",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_18 = { class: "date-status-inner" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "pr-1" }, "verpasst")
], -1))
const _hoisted_20 = { class: "item-prio px-0 text-small" }
const _hoisted_21 = {
  class: "item-prio-label",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_22 = { class: "pr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    'item-progress-bar-wrapper',
    _ctx.picklist.Tour.length ? 'item-progress-tour-inside' : '',
    `item-progress-date-${_ctx.picklist.DatumStatus}`,
    'item-progress-bar-wrapper'
  ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.picklist.Tour.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.picklist.Tour.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    color: _ctx.picklist.StatusColor,
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        start: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-truck-delivery-outline")
                        ], undefined, true),
                        _: 1
                      }),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.picklist.Tour, (tour) => {
                          return (_openBlock(), _createElementBlock("b", {
                            key: tour.Tournr
                          }, "Tour " + _toDisplayString(tour.Tournr), 1))
                        }), 128))
                      ])
                    ], undefined, true),
                    _: 1
                  }, 8, ["color"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.TourdatumvonTime), 1)
                    ])
                  ])
                ], undefined, true),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_chip, {
            class: _normalizeClass(["bg-white", `${_ctx.picklist.StatusColor} pl-1 `]),
            variant: "outlined",
            dense: "",
            color: _ctx.picklist.StatusColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                color: `${_ctx.picklist.StatusColor}`,
                small: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.picklist.Kmsbediener), 1)
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["color"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("small", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.picklist.StatusName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.picklist.KmsdatumDate) + " " + _toDisplayString(_ctx.picklist.Kmsuhrzeit), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_v_icon, { end: "" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-" + _toDisplayString(_ctx.picklist.StatusIcon), 1)
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }, 8, ["color", "class"])
        ])
      ]),
      (_ctx.picklist.Tour.length && _ctx.picklist.StatusCode === 'done' || _ctx.picklist.Tour.length && _ctx.picklist.DatumStatus === 'active')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.TourdatumbisTime), 1)
                    ])
                  ])
                ], undefined, true),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.picklist.DatumStatus === 'passed' && _ctx.picklist.StatusCode !== 'done')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['date-status', `date-status-${_ctx.picklist.DatumStatus}`])
        }, [
          _createVNode(_component_v_chip, {
            color: "error",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("small", _hoisted_22, _toDisplayString(_ctx.TourdatumbisTime), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-clock-alert")
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}